export default __webpack_public_path__ + "static/media/image.b5ce947c.svg";